import { Table, Pagination } from "antd";
import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "../../../../components/modelpopup/EmployeeLeaveModelPopup";
import SearchBox from "../../../../components/SearchBox";
import { base_url } from "../../../../base_urls";
import {
  getLeaveSummary,
  getLeaveList,
  getLeaveDetail,
} from "api/services/leave";
import {
  itemRender,
  handlePageChange,
  defaultPagination,
  pageSizeOptions,
} from "utils/table";
import { useSearchParams } from "react-router-dom";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Image from "components/Image";
import { formatDateHandler2 } from "utils/common";
import { getLeaveType } from "api/services/common";
import EmployeeLeaveFilter from "../components/employeeLeaveFilter";
import useEmployeeLeaveFilter from "../hooks/filterLeaveHook";
import FilterDrawer from "components/Drawer/leaveFilterDrawer";
import { filterHandler } from "utils/common";
import { SkeltonLoader } from "components/skeltonLoader";
import { Button } from "components/Button";
import { useMediaQuery } from "react-responsive";

const EmployeeLeave = () => {
  const [leaveSummary, setLeaveSummary] = useState({});
  const [users, setUsers] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [leavesLoading, setLeavesLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [leaveModal, setLeaveModal] = useState(false);

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [selectedLeave, setSelectedLeave] = useState("");
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);

  const [view, setView] = useState(isMobile ? "grid" : "list");
  const { user, userLoading } = useSelector((state) => state.user);

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const getFilterParams = useCallback(() => {
    let filter_params = filterHandler(filters);

    return filter_params;
  });

  useEffect(() => {
    // console.log(id, modal, "MMM")
    const id = queryParams.get("id"); // Get 'id' param
    const modal = queryParams.get("modal"); // Get 'name' param
    // const { search } = useLocation();
    // const queryParams = new URLSearchParams(location?.search);
    console.log(queryParams, id, modal, queryParams, "MMM");

    if (id && modal) {
      getLeaveDetail(id, {}).then((response) => {
        console.log(response.data, "LLLL");
        handleLeaveAction(response.data);
      });
    }
  }, []);
  useEffect(() => {
    getLeaveType().then((res) => {
      setLeaveTypes(
        res.data.results.map((item) => {
          return {
            label: `${item.description}`,
            value: item.id,
          };
        })
      );
    });
  }, []);

  const navigate = useNavigate();

  const [pageSettings, setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",
  });

  const wrapText = (text, maxLength = 15) => {
    if (!text) return "";
    return text.match(new RegExp(`.{1,${maxLength}}`, "g")).join("\n");
  };

  const {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading,
    setFilterLoading,
    handleDateChange,
  } = useEmployeeLeaveFilter(pageSettings, setPageSettings);

  useEffect(() => {
    // axios
    //   .get(base_url + "/api/adminleaves.json")
    //   .then((res) => setUsers(res.data));

    getLeaveSummary().then((res) => {
      console.log(res.data, "DATAAAA");
      setLeaveSummary(res.data);
    });
  }, []);

  const fetchLeaveList = () => {
    setLoading(true);
    setLeavesLoading(true);
    let filter_params = getFilterParams();
    getLeaveList({
      sort_by: pageSettings?.sortBy,
      sort_type: pageSettings?.sortType,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      ...filter_params,
    })
      .then((res) => {
        setPageSettings({
          ...pageSettings,
          total: res.data.count
        })
        if (view == "grid" && pageSettings?.page !== 1) {
          setLeaves([...leaves, ...res.data.results]);
        } else {
          setLeaves(res.data.results);
        }

        setLoading(false);
        setShowFilterDrawer(false);
        setLeavesLoading(false);
      })
      .catch((e) => {
        setLeaves([]);
        setLoading(false);
        setLeavesLoading(false);
      });
  };
  useEffect(() => {
    fetchLeaveList();
  }, [
    pageSettings?.page,
    pageSettings?.pageSize,
    pageSettings?.sortBy,
    pageSettings?.sortType,
    pageSettings?.filters,
  ]);

  const handleLeaveAction = (record) => {
    setSelectedLeave(record);
    setLeaveModal(true);
  };

  const columns = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   sorter: true,
    // },
    {
      title: "Name",
      dataIndex: "company_user__first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2
          onClick={() => handleLeaveAction(record)}
          className="table-avatar d-flex"
        >
          <a className="avatar">
            {/* <img alt="" src={record.profile_image} /> */}
            <Image
              src={record?.company_user?.profile_image}
              type="user"
              style={{ objectFit: "cover" }}
            />
          </a>
          <div>
            <a
              // onClick={()=>handleEmployeeDetailPage(record.id, index)}
              className="profile-split d-flex flex-column"
            >
              {record.company_user?.first_name}{" "}
              {record?.company_user?.last_name}
            </a>
            {record?.company_user?.emp_no && (
              <span className="small text-muted">
                {record.company_user?.emp_no}
              </span>
            )}
          </div>
        </h2>
      ),
    },
    // {
    //   title: "Position",
    //   dataIndex: "position_name",
    //   // sorter: true,
    //   render: (text, record, index) => (
    //       <span>{record?.company_user?.position_name}</span>

    //   ),
    //   align:"center"

    // },
    {
      title: "Leave Type",
      dataIndex: "leave_type__code",
      render: (text, record) => <span>{record?.leave_type?.description}</span>,
      sorter: true,
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      render: (text, record) => <span>{formatDateHandler2(text)}</span>,
      sorter: true,
    },

    {
      title: "From",
      dataIndex: "start_date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
      align: "center",
    },
    {
      title: "To",
      dataIndex: "end_date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
      align: "center",
    },

    {
      title: "Total Days",
      dataIndex: "no_of_days",
      render: (text) => <span>{text}</span>,
      // sorter: true,
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "approval_status",
      sorter: true,
      render: (text) => (
        <div className="dropdown action-label text-center">
          <span
            className={`badge badge-soft-${
              (text == "pending" || text == "cancel_pending")
                ? "warning"
                : text == "rejected"
                ? "danger"
                : "success"
            }`}
          >
            {text.replace("_", " ")}
          </span>
        </div>
      ),
    },
    {
      title: "Cost Center",
      dataIndex: "company_user__cost_center",
      render: (text, record) => <span>{record?.cost_center?.code || ""}</span>,
      sorter: true,
      align: "center",
    },
    {
      title: "Current Approver",
      // dataIndex: "approved_by",
      dataIndex: "current_approver__first_name",
      sorter: true,
      render: (text, record) => (
        <h2 className="table-avatar d-flex">
          {record?.current_approver && (
            <>
              <a
                // onClick={()=>handleEmployeeDetailPage(record.id, index)}
                className="avatar"
              >
                {/* <img alt="" src={record.profile_image} /> */}
                <Image
                  src={record?.current_approver?.profile_image}
                  type="user"
                  style={{ objectFit: "cover" }}
                />
              </a>
              <a
                // onClick={()=>handleEmployeeDetailPage(record.id, index)}
                className="profile-split d-flex flex-column"
              >
                {record.current_approver?.first_name}{" "}
                {record?.current_approver?.last_name}
                {record?.current_approver?.emp_no && (
                  <span className="small text-muted">
                    {record.current_approver.emp_no}
                  </span>
                )}
              </a>
            </>
          )}
        </h2>
      ),
    },
    {
      title: "Approved on",
      dataIndex: "approved_on",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
    },
    {
      title: "Role Delegation",
      dataIndex: "role_delegation__first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          {record?.role_delegation && (
            <>
              <a className="avatar">
                {/* <img alt="" src={record.profile_image} /> */}
                <Image
                  src={record?.role_delegation?.profile_image}
                  type="user"
                  style={{ objectFit: "cover" }}
                />
              </a>
              <div>
                <a
                  // onClick={()=>handleEmployeeDetailPage(record.id, index)}
                  className="profile-split d-flex flex-column"
                >
                  {record.role_delegation?.first_name}{" "}
                  {record?.role_delegation?.last_name}
                </a>
                {record?.role_delegation?.emp_no && (
                  <span className="small text-muted">
                    {record.role_delegation?.emp_no}
                  </span>
                )}
              </div>
            </>
          )}
        </h2>
      ),
    },
    {
      title: "Comments",
      dataIndex: "comment",
      sorter: true,
      render: (text) => (
        <span
          style={{
            display: "inline-block",
            minWidth: "15ch",   // Minimum width ~15 characters
            maxWidth: "100%",   // Allow wrapping if content exceeds
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Attachments",
      dataIndex: "attachments",
      render: (text, record) => {
        let str =
          record.attachments.length == 1 ? " Attachment" : " Attachments";
        return (
          <>
            <span className="file-attached">
              <i className="fa fa-paperclip" />
            </span>
            {" " + record.attachments.length + str}
          </>
        );
      },
      sorter: true,
      align: "center",
    },
    {
      title: "Action",
      className: "text-end",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={() => handleLeaveAction(record)}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            {/* <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link> */}
          </div>
        </div>
      ),
    },
  ];
  const leaveStats = [
    {
      id: 1,
      title: "Annual Leave",
      value: 12,
    },
    {
      id: 2,
      title: "Medical Leave",
      value: 3,
    },
    {
      id: 3,
      title: "Other Leave",
      value: 4,
    },
    {
      id: 4,
      title: "Remaining Leave",
      value: 5,
    },
  ];
  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings);
    console.log(pageData);
    // setSearchParams({
    //     size: pageData?.pageSize,
    //     page: pageData?.page,
    //     sort_by: pageData?.sortBy || "",
    //     sort_type: pageData?.sortType || ""
    // })
    setPageSettings(pageData);
  };

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ");
    setShowFilterDrawer(!showFilterDrawer);
    setFilterLoading(false);
  };

  const handleApplyFilter = () => {
    let _appliedFilters = filters.filter(
      (item) => item.value && item.key != "search"
    );
    setAppliedFilterCount(_appliedFilters.length);

    // setFilterLoading(true)
    setPageSettings({
      ...pageSettings,
      page: 1,
      filters,
    });
    // getEmployeeList()
  };

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {leaves.map((record, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6">
              <div className="contact-grid">
                <div className="grid-head">
                  <div className="users-profile">
                    <a
                      onClick={() => handleLeaveAction(record)}
                      className="avatar"
                    >
                      {/* <img src={employee?.profile_image} alt="" /> */}
                      <Image
                        src={record.company_user?.profile_image}
                        type="user"
                        alt="User Image"
                        style={{ objectFit: "cover" }}
                      />
                    </a>
                    <h5 className="name-user">
                      <a onClick={() => handleLeaveAction(record)}>
                        {record.company_user?.first_name}{" "}
                        {record?.company_user?.last_name}{" "}
                      </a>
                      <span>{record.company_user?.emp_no}</span>
                    </h5>
                  </div>
                </div>
                <div className="grid-body">
                  <div className="address-info">
                    <span>
                      <i className="la la-calendar" />
                      From : {formatDateHandler2(record.start_date)}
                      {/* sharon@gmail.com */}
                    </span>
                    <span>
                      <i className="la la-calendar" />
                      To : {formatDateHandler2(record.end_date)}
                    </span>
                    <span>
                      <i className="la la-calendar-week" />
                      Number of days : {record.no_of_days}
                    </span>
                    <span>
                      {/* <i className="la la-calendar-week" /> */}
                      Current Approver : {
                        record.current_approver?.first_name
                      }{" "}
                      {record.current_approver?.last_name}
                    </span>
                    <span>
                      <i className="la la-company" />
                      Cost Center: {record.cost_center?.code}
                    </span>
                  </div>

                  <div className="grid-badges">
                    <span className="badge badge-soft-warning">
                      {record?.leave_type?.description}
                    </span>
                    <span
                      className={`badge badge-soft-${
                        record?.approval_status == "pending"
                          ? "warning"
                          : record?.approval_status == "rejected"
                          ? "danger"
                          : "success"
                      }`}
                    >
                      {record?.approval_status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const handleGridChange = (page, size) => {
    console.log(page, size, ")))))))))))))");
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    });
    // setSearchParams({
    //     size,
    //     page,
    // })
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Leaves"
            title="Dashboard"
            subtitle="Leaves"
            modal="#add_leave"
            name="Apply Leave"
            setLeaveModal={setLeaveModal}
            // hideGrid={true}
            view={view}
            setView={setView}
          />

          <div className="row">
            {/* {leaveStats.map((stat, index) => (
              <div className="col-md-3" >
                <div className="stats-info">
                  <h6>{stat.title}</h6>
                  <h4>{stat.value}</h4>
                </div>
              </div>
            ))} */}
            <div className="col-md-3">
              <div className="stats-info">
                <h6>Pending Request</h6>
                <h4>{leaveSummary?.pending_request || 0}</h4>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stats-info">
                <h6>Planned Leave This Month</h6>
                <h4>{leaveSummary?.planned_leaves_this_month || 0}</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stats-info">
                <h6>Planned Leave This Week</h6>
                <h4>{leaveSummary?.planned_leaves_this_week || 0}</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="stats-info">
                <h6>Planned Leave Today</h6>
                <h4>{leaveSummary?.planned_leaves_today || 0}</h4>
              </div>
            </div>
          </div>

          {/* {user.role?.access_scope !== "self" && ( */}
            <div className="row">
              <EmployeeLeaveFilter
                filters={filters}
                handleInputChange={handleInputChange}
                searchPlaceholder={"Search leave"}
                handleFilterDrawer={handleFilterDrawer}
                handleFilterChange={handleFilterChange}
                loading={loading}
                leaveTypes={leaveTypes}
                appliedFilterCount={appliedFilterCount}
              />
            </div>
          {/* )} */}

          {view == "grid" ? (
            <div className="row">
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                {
                    console.log(pageSettings, "LLLLL")
                  }
                  
                  {/* <SearchBox /> */}
                  <Table
                    // // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                    columns={columns}
                    dataSource={leaves}
                    className="table-striped"
                    rowKey={(record) => record.id}
                    loading={leavesLoading}
                    pagination={{
                      total: pageSettings?.total,
                      pageSize: pageSettings?.pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: pageSizeOptions,
                      // showQuickJumper: true,
                      itemRender: itemRender,
                      position: "right",
                      current: pageSettings?.page,
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Add Leave Modal */}
      <EmployeeLeaveModelPopup
        fetchLeaveList={fetchLeaveList}
        selectedLeave={selectedLeave}
        setSelectedLeave={setSelectedLeave}
        leaveTypes={leaveTypes}
        leaveModal={leaveModal}
        setLeaveModal={setLeaveModal}
        user={user}
      />
      {/* Add Leave Modal */}
      {/* Delete Modal */}
      <DeleteModal Name="Delete Leaves" />
      {/* Delete Modal */}

      <FilterDrawer
        searchPlaceholder={"Search leave"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
        leaveTypes={leaveTypes}
      />
    </>
  );
};

export default EmployeeLeave;
